import { ImageSearchResultCard } from '@monash/portal-frontend-common';
import { resolveCategoryNames } from './resolve-category-names';

export const ImageTileAdapter = ({ entity, allCategories, className }) => {
  const {
    linkType,
    name,
    description,
    displayLabel,
    categories,
    image,
    links,
    url,
  } = entity ?? {};

  // url is deprecated. eventually the frontend will support multiple links
  const finalUrl = links?.[0].url || url;

  return (
    <ImageSearchResultCard
      linkType={linkType}
      name={name}
      description={description}
      displayLabel={displayLabel}
      categoryNames={resolveCategoryNames(categories, allCategories)}
      url={finalUrl}
      imageUrl={image?.url}
      className={className}
    />
  );
};
